// extracted by mini-css-extract-plugin
export default {"container":"Portfolio_container__rN7dw","list":"Portfolio_list__TN+0Z","cardBox":"Portfolio_cardBox__k2Qn5"};